import React from "react";
import VibeCard from "./VibeCard";

const VibeList = ({ list, activeTab }) => {
  if (!list.length) return null;
  return (
    <div className="space-y-3">
      {list.map((vibe) => (
        <VibeCard key={vibe.id} vibe={vibe} activeTab={activeTab} />
      ))}
    </div>
  );
};

export default VibeList;
